import NewsTipStatus from './NewsTipStatus'
export default NewsTipStatus
